<template>
  <v-container fluid>
    <v-btn
      :to="{ name: 'admin.index' }"
      elevation="0"
      tile
      icon
    >
      <v-icon size="20">mdi-arrow-left</v-icon>
    </v-btn>

    <v-divider class="mb-3 mt-1"></v-divider>
    <v-row>
      <v-col cols="3">
        <v-switch
          class="ml-2 mr-2"
          @change="clear"
          v-model="toggleWindow"
          :label="!toggleWindow ? 'Switch to Member Groups tool' : 'Switch to Group Management'"
        ></v-switch>
      </v-col>
      <v-col cols="9">
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <v-container v-if="!toggleWindow" class="justify-center">
        <v-form>
          <div class="map__overlay" v-if="loadingRemoveOrAddGroup">
            <v-progress-circular
              color="primary"
              size="50"
              indeterminate
            ></v-progress-circular>
          </div>
          <v-row class="mb-4 groups-container">
            <v-col cols='3' class="d-none d-md-block p-0 mb-0">
              <h2 style="color:blue;">New group tool</h2>
              <v-divider style="border-color:blue;"></v-divider>
            </v-col>
            <v-col cols="9">
            </v-col>
            <v-col cols="9">
              <v-text-field
                clearable
                label="Write your new group name"
                v-model="group.name"
                :rules="[rules.availableName]"
                @keydown:enter="submitGroup"
              ></v-text-field>
              <v-alert
                dense
                text
                :value="createdAlert"
                type="success"
              >
                {{group.name}} created
              </v-alert>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-center">
              <v-btn
                @click.prevent="submitGroup"
                type="submit"
                color="primary"
                :disabled="verifyExistingGroups(group.name) !== true ? true : false ||
                  group.name === '' || group.name === null"
              ><v-icon class="mr-2">mdi-account-group</v-icon>Add new group</v-btn>
            </v-col>
          </v-row>
          <v-row class="groups-container">
            <v-col cols='4' class="d-none d-md-block p-0 mb-0">
              <h2 style="color:blue;">Group management tool</h2>
              <v-divider style="border-color:blue;"></v-divider>
            </v-col>
            <v-col cols="8">
            </v-col>
            <v-col cols="9">
              <v-select
                :items="groupSelectorItems"
                v-model="selectedGroup"
                @change="assignGroup"
                menu-props="auto"
                label="Select a group"
                hide-details
                outlined
              ></v-select>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-center">
              <v-dialog
                v-model="addMemberDialog"
                scrollable
                max-width="800px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    v-on="on"
                    :disabled="!selectedGroup"
                  ><v-icon class="mr-2">mdi-account-supervisor-circle</v-icon>Add new member</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <v-row>
                    <v-col cols="10" class="text-center">
                      <v-text-field
                        v-model="newMemberEmail"
                        label="Type the new member´s email"
                        clearable
                        @keydown.enter.prevent="AddPreviewNewMembers"
                        :rules="[rules.email]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-center align-center">
                      <v-btn
                        @click="AddPreviewNewMembers"
                        color="primary"
                        :disabled="newMemberEmail === null || newMemberEmail === ''"
                      ><v-icon class="mr-2">mdi-account-plus</v-icon>Add</v-btn>
                    </v-col>
                    </v-row>
                  </v-card-title>
                  <v-divider style="border-color:blue"></v-divider>
                  <v-card-text style="max-height: 300px;">
                    <v-row>
                      <v-col cols="2">
                        <v-spacer></v-spacer>
                      </v-col>
                      <v-col cols="8" class="text-left">
                        <v-list-item
                          v-for="email in toAddEmails"
                          :key="email"
                          >
                          <v-list-item-content>
                            <v-row class="d-flex justify-center align-center">
                              <v-col cols="2">
                                <v-icon>mdi-account-circle</v-icon>
                              </v-col>
                              <v-col cols="8" class="text-center">
                                <h3>{{email}}</h3>
                              </v-col>
                              <v-col cols="2">
                                <v-icon
                                color="error"
                                @click="remove(toAddEmails, email)">mdi-close-circle</v-icon>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="2">
                        <v-spacer></v-spacer>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider style="border-color:blue"></v-divider>
                  <v-card-actions class="d-flex justify-end align-center">
                    <v-btn
                      color="error"
                      @click="clearAddMemberModal"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="submitNewMembers"
                    >
                      Add member(s)
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="12" v-if="deleteGroupAlert === true">
              <v-alert
                dense
                prominent
                icon="mdi-account-supervisor-circle"
                text
                :value="deleteGroupAlert"
                type="error"
                class="d-flex justify-center"
              >
                Group deleted!
              </v-alert>
            </v-col>
            <div v-if="selectedGroup" class="pr-2 pl-2" style="width:100%">
              <v-row>
                <v-col cols="3">
                </v-col>
                <v-col cols="6" class="text-center align-center d-flex justify-center">
                  <h3>{{form.name}}</h3>
                </v-col>
                <v-col cols="3" class="text-center">
                  <v-btn
                    @click.prevent="submitDeleteGroup"
                    type="button"
                    color="error"
                    class="mr-3"
                    :disabled="Object.entries(form).length === 0 ? true : false"
                  >Delete group</v-btn>
                </v-col>
                <v-col cols='12' class="d-none d-md-block p-0 mb-0">
                  <v-divider style="border-color:blue; border-width: 1.1px;"></v-divider>
                </v-col>
                <v-col cols="12" v-if="noMembers">
                  <v-alert
                    dense
                    prominent
                    text
                    :value="membersListAlert"
                    type="info"
                    color="primary"
                    class="d-flex justify-center"
                  >
                    This group doesn´t have any members.
                  </v-alert>
                </v-col>
                <v-col cols="12" v-if="loadingList" class="d-flex justify-center align-center">
                  <v-progress-circular
                    color="primary"
                    size="50"
                    indeterminate
                  ></v-progress-circular>
                </v-col>
                <v-col cols="12" v-if="membersListAlert === true">
                  <v-alert
                    dense
                    prominent
                    icon="mdi-account-group"
                    text
                    :value="membersListAlert"
                    type="info"
                    color="primary"
                    class="d-flex justify-center"
                  >
                    Users updated!
                  </v-alert>
                </v-col>
                <v-col
                  cols="4"
                  v-for="email in visibleEmails"
                  :key="email">
                  <v-checkbox
                    v-model="toDeleteEmails"
                    :label="email"
                    :value="email"
                    hide-details
                    dense
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>
          </v-row>
          <v-row class="mt-2" v-if="selectedGroup">
            <v-col cols="12" class="text-right">
              <v-btn
                @click.prevent="DeleteUsersSelected"
                color="error"
                :disabled="toDeleteEmails.length <= 0"
              ><v-icon class="mr-2">mdi-account-supervisor-circle</v-icon>Detach Selected</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="selectedGroup">
            <v-col cols="12" class="d-flex justify-center align-center">
              <v-pagination
                v-model="page"
                :length="Math.ceil(userEmails.length/perPage)"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-form>
    </v-container>
    <v-container v-else class="justify-center">
        <v-form>
          <v-row class="groups-container">
            <v-col cols='5' class="d-none d-md-block p-0 mb-0">
              <h2 style="color:blue;">Member´s groups management tool</h2>
              <v-divider style="border-color:blue;"></v-divider>
            </v-col>
            <v-col cols="7">
            </v-col>
            <v-col cols="10" class="text-center">
              <v-text-field
                v-model="emailToFind"
                label="Search user by email"
                clearable
                @click:clear="clear"
                @keydown.enter.prevent="validateEmail(emailToFind) !== false ? search() : ''"
                :rules="[rules.email]"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">
              <v-btn
                @click="search()"
                :disabled="!validateEmail(emailToFind)"
              ><v-icon class="mr-2">mdi-magnify</v-icon>Search</v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-4 pt-2 pb-4 groups-container">
            <v-col cols="12"
            v-if="userSelected !== null" style="color:blue"
            class="text-center d-flex justify-center mt-4">
              <v-icon class="mr-2" color="primary">mdi-account-circle</v-icon>
              <h3>{{userSelected}}</h3>
            </v-col>
            <v-col cols="10">
              <v-select
                :items="groupSelectorItems"
                v-model="selectedGroup"
                @change="assignGroup"
                menu-props="auto"
                label="Select a group"
                hide-details
                outlined
                :disabled="emailSearch === null"
              ><template slot="no-data">
                  <div class="text-center mt-2 mb-2">
                    <v-icon class="mr-2">mdi-account-supervisor-circle</v-icon>
                    No more groups available!
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">
              <v-btn
                @click.prevent="submitUserToGroup"
                type="submit"
                color="primary"
                :disabled="!selectedGroup || emailToFind === null"
              ><v-icon class="mr-2">mdi-account-supervisor-circle</v-icon>Add group</v-btn>
            </v-col>
            <v-col cols='12' class="d-none d-md-block p-0 mb-0" v-if="userSelected !== null">
              <hr style="border-bottom: 1px solid blue; padding:0; margin-top:0"/>
            </v-col>
            <v-col cols="12" v-if="loadingList" class="d-flex justify-center align-center">
              <v-progress-circular
                color="primary"
                size="50"
                indeterminate
              ></v-progress-circular>
            </v-col>
            <v-col
              cols="12"
              v-if="!validEmail"
            >
              <v-alert type="error" icon="mdi-account-circle" class="d-flex justify-center">
                This user doesn´t exists !
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="userGroupsListAlert === true">
              <v-alert
                dense
                prominent
                icon="mdi-account-supervisor-circle"
                text
                :value="membersListAlert"
                type="info"
                color="primary"
                class="d-flex justify-center"
              >
                Groups updated!
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="noGroups">
              <v-alert
                dense
                prominent
                text
                :value="membersListAlert"
                type="info"
                color="primary"
                class="d-flex justify-center"
              >
                This member doesn´t have any groups.
              </v-alert>
            </v-col>
            <v-col cols="4" v-for="g in visibleGroups" :key="g">
              <v-checkbox
                v-model="toDeleteGroups"
                :label="g"
                :value="g"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="userSelected !== null">
            <v-col cols="12" class="text-right">
              <v-btn
                @click.prevent="removeUserMultipleGroups"
                type="submit"
                color="error"
                :disabled="toDeleteGroups.length <= 0"
              ><v-icon class="mr-2">mdi-account-supervisor-circle</v-icon>Detach Selected</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="userSelected !== null">
            <v-col cols="12" class="d-flex justify-center align-center">
              <v-pagination
                v-model="page"
                :length="Math.ceil(emailGroups.length/perPage)"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-form>
    </v-container>
  </v-container>
</template>

<script>
import { Groups, Auth } from '@/api';
// eslint-disable-next-line
const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  name: 'app-groups-create',
  data() {
    return {
      // Properties to add all of emails
      // textAreaText: null,
      // textAreaEmails: [],
      deleteGroupAlert: false,
      userGroupsListAlert: false,
      validEmail: true,
      toAddEmails: [],
      newMemberEmail: null,
      addMemberDialog: false,
      loadingRemoveOrAddGroup: false,
      loadingList: false,
      page: 1,
      perPage: 12,
      toDeleteEmails: [],
      toDeleteGroups: [],
      emailToFind: null,
      emailSearch: null,
      emailGroups: [],
      toggleWindow: false,
      selectedGroup: null,
      createdAlert: false,
      membersListAlert: false,
      availableGroups: [],
      group: { name: '' },
      form: {},
      userEmails: [],
      rules: {
        availableName: value => this.verifyExistingGroups(value) || 'This group already exists',
        required: value => !!value || 'Required.',
        email: (value) => {
          const pattern = regex;
          if (value !== null) {
            const found = this.toAddEmails.find(i => i === this.newMemberEmail);
            const foundemailInGroup = this.userEmails.find(i => i === this.newMemberEmail);
            if (found) {
              return 'This user email it´s already added to this list';
            }
            if (foundemailInGroup) {
              return 'This member email already exists in this group';
            }
            return pattern.test(value) || 'Invalid e-mail.';
          }
          return true;
        },
      },
    };
  },
  computed: {
    visibleGroups() {
      return this.emailGroups.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
    visibleEmails() {
      return this.userEmails.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
    userSelected() {
      if (this.emailSearch === null || this.emailSearch === '') {
        return null;
      }
      let letters = '';
      const names = this.emailSearch.replace(/@.*/g, '')
        .split('.')
        .filter(Boolean);

      if (names.length > 1) {
        letters = names.map(name => name[0].toUpperCase())
          .join('');
      } else {
        letters = names[0].slice(0, 2)
          .toUpperCase();
      }

      return letters;
    },
    noMembers() {
      if (this.selectedGroup && this.userEmails.length > 0) {
        return false;
      }
      if (!this.membersListAlert) {
        return true;
      }
      return false;
    },
    noGroups() {
      if (this.validEmail && this.visibleGroups.length <= 0 && this.emailSearch) {
        if (!this.userGroupsListAlert) {
          return true;
        }
        return false;
      }
      return false;
    },
    toDeleteGroupsFormFormat() {
      const groupsWithFormat = this.toDeleteGroups.map((group) => {
        const foundGroup = this.availableGroups.find(item => item.name === group);
        return foundGroup;
      });
      return groupsWithFormat;
    },
    groupSelectorItems() {
      return this.availableGroups
        .map(item => ({
          text: item.name,
          value: item.guid,
        }))
        .sort((a, b) => (
          a.text > b.text ? 1 : -1
        ))
        .filter(x => !this.emailGroups.includes(x.text));
    },
  },
  methods: {
    // method to add all of emails
    // addLotEmails() {
    //   if (this.textAreaText !== '') {
    //     this.textAreaEmails = this.textAreaText.trim().split('\n');
    //     console.log(this.userEmails.length);
    //     console.log(this.textAreaEmails.length);
    //     if (this.textAreaEmails.length > 0) {
    //       this.userEmails = this.userEmails.concat(this.textAreaEmails);
    //       this.userEmails = this.userEmails.filter((v, i, a) => a.indexOf(v) === i);
    //       console.log(this.userEmails.length);
    //     }
    //   }
    // },
    validateEmail(email) {
      if (email !== null || email !== '') {
        return regex.test(email);
      }
      return false;
    },
    AddPreviewNewMembers() {
      if (this.newMemberEmail) {
        const emails = this.newMemberEmail.split(/\n|\s/g).filter(Boolean);
        this.toAddEmails.push(...emails);
        this.newMemberEmail = null;
      }
    },
    clear() {
      this.toDeleteGroups = [];
      this.selectedGroup = null;
      this.emailToFind = null;
      this.emailGroups = [];
      this.emailSearch = null;
      this.form = {};
      this.userEmails = [];
      this.validEmail = true;
    },
    clearAddMemberModal() {
      this.addMemberDialog = false;
      this.toAddEmails = [];
      this.newMemberEmail = null;
    },
    async validateEmailBeforeSearch() {
      const getEmail = (await Auth.validateEmail({ params: { email: this.emailToFind } })).data;
      this.validEmail = getEmail;
    },
    search: (function debounce() {
      let time = 0;
      return async function search() {
        this.loadingList = true;
        this.toDeleteGroups = [];
        this.emailSearch = this.emailToFind;
        this.validateEmailBeforeSearch(this.emailSearch);
        const self = this;
        clearTimeout(time);
        time = setTimeout(async () => {
          self.emailGroups = [];
          if (self.emailToFind) {
            this.page = 1;
            (await Groups.fetch({ email: self.emailToFind }))
              .data
              .map((p) => {
                self.emailGroups.push(p.name);
                return p;
              });
          }
          this.loadingList = false;
        }, 500);
      };
    }()),
    verifyExistingGroups(newNameGroup) {
      const foundName = this.availableGroups.find((group) => {
        let founded = '';
        let testName = newNameGroup;
        if (testName === null) {
          testName = '';
        }
        if (group.name !== '') {
          founded = group.name.toLowerCase() === testName.toLowerCase();
        }
        return founded;
      });
      if (foundName === undefined) {
        return true;
      }
      return false;
    },
    assignGroup(eventSelectGroup) {
      this.toDeleteEmails = [];
      const valueD = this.availableGroups.find(item => item.guid === eventSelectGroup);
      this.form = valueD;
      if (this.form.email === null) {
        this.userEmails = [];
      } else {
        this.userEmails = this.form.email.split(',');
        this.page = 1;
      }
    },
    async fetch() {
      this.$store.commit('START_LOADING');

      try {
        this.availableGroups = (await Groups.fetch()).data;
      } catch (e) {
        console.debug('ERROR', e);
      }

      this.$store.commit('END_LOADING');
    },
    async submitGroup(event) {
      event.preventDefault();
      try {
        this.loadingRemoveOrAddGroup = true;
        this.createdAlert = true;
        await Groups.create(this.group);
        setTimeout(() => { this.createdAlert = false; }, 1000);
      } catch (e) {
        console.debug('ERROR', e);
      }
      await this.fetch();
      setTimeout(() => { this.group.name = ''; }, 1000);
      this.loadingRemoveOrAddGroup = false;
    },
    reset() {
      this.selectedGroup = null;
      this.form = {};
      this.userEmails = [];
      // Reset initial values to add all of emails
      // this.textAreaText = null;
      // this.textAreaEmails = [];
    },
    cleanAndDetachUserFromGroups() {
      this.toDeleteGroupsFormFormat.forEach((group, idx) => {
        if (this.emailSearch !== null || this.emailSearch !== '') {
          const setToArray = group.email.split(',');
          this.remove(setToArray, this.emailSearch);
          this.toDeleteGroupsFormFormat[idx].email = setToArray.join(',');
          if (setToArray.length <= 0) {
            this.toDeleteGroupsFormFormat[idx].email = null;
          }
        }
      });
    },
    async removeUserMultipleGroups() {
      this.cleanAndDetachUserFromGroups();
      if (this.toDeleteGroupsFormFormat.length > 0) {
        try {
          this.loadingList = true;
          await Groups.updateMany(this.toDeleteGroupsFormFormat);
        } catch (e) {
          console.debug('ERROR', e);
        }
        await this.fetch();
        this.toDeleteGroups = [];
        await this.search();
        this.userGroupsListAlert = true;
        setTimeout(() => { this.userGroupsListAlert = false; }, 1500);
        this.loadingList = false;
      }
    },
    remove(arrayFrom, item) {
      let removeArray = arrayFrom.splice(arrayFrom.indexOf(item), 1);
      removeArray = [...removeArray];
      return removeArray;
    },
    DeleteUsersSelected() {
      this.toDeleteEmails.forEach(i => this.remove(this.userEmails, i));
      this.submitNewMembers();
      this.toDeleteEmails = [];
    },
    async submitUserToGroup() {
      this.toAddEmails.push(this.emailSearch);
      this.submitNewMembers();
      await this.fetch();
      await this.search();
    },
    async submitNewMembers() {
      let presentEmails = this.toAddEmails.reverse().concat(this.userEmails);
      presentEmails = presentEmails.filter((v, i, a) => a.indexOf(v) === i);
      this.form.email = presentEmails.join(',');
      if (this.form.email.length <= 0) {
        this.form.email = null;
      }

      try {
        this.loadingList = true;
        this.addMemberDialog = false;
        await Groups.update(this.form);
      } catch (e) {
        console.debug('ERROR', e);
      }

      await this.fetch();
      this.newMemberEmail = null;
      this.toAddEmails = [];
      await this.assignGroup(this.form.guid);
      // For groups managment list
      this.membersListAlert = true;
      setTimeout(() => { this.membersListAlert = false; }, 1500);
      // For user groups managment list
      this.userGroupsListAlert = true;
      setTimeout(() => { this.userGroupsListAlert = false; }, 1500);
      this.loadingList = false;
    },
    async submitDeleteGroup() {
      try {
        this.loadingRemoveOrAddGroup = true;
        await Groups.delete(this.form.guid);
        this.deleteGroupAlert = true;
      } catch (e) {
        console.debug('ERROR', e);
      }

      await this.fetch();
      this.reset();
      setTimeout(() => { this.deleteGroupAlert = false; }, 1500);
      this.loadingRemoveOrAddGroup = false;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
